export const verifyEmailMarkup = String.raw`<!-- ====== VERIFY EMAIL OVERLAY ====== -->
<div class="modal-overlay" id="verifyEmailOverlay" style="z-index:10010;">
  <div class="modal modal-auth modal-auth-narrow">
    <div class="modal-auth-brand">
      <img class="auth-brand-logo" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox">
    </div>
    <div id="verifyEmailLoading" class="modal-auth-body" style="text-align:center;padding:20px 0;">
      <div class="auth-spinner" style="margin:0 auto 16px;"></div>
      <h4 class="forgot-success-title">Verifying your email...</h4>
      <p class="forgot-success-detail">Please wait while we confirm your email address.</p>
    </div>
    <div id="verifyEmailSuccess" class="modal-auth-body" style="display:none;text-align:center;padding:20px 0;">
      <div class="forgot-success-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--success)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </div>
      <h4 class="forgot-success-title">Email verified!</h4>
      <p class="forgot-success-detail">Your email has been verified. Redirecting you to the home page...</p>
    </div>
    <div id="verifyEmailError" class="modal-auth-body" style="display:none;text-align:center;padding:20px 0;">
      <div class="forgot-success-icon" style="color:var(--error);">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--error)" stroke-width="2.5"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
      </div>
      <h4 class="forgot-success-title">Verification failed</h4>
      <p class="forgot-success-detail">The verification link is invalid or has expired. Sign in with the pending account to request a fresh link securely.</p>
      <button class="btn btn-primary btn-lg w-full auth-primary-btn" data-proto-click="closeVerifyEmailOverlay();showLoginModal();return false;">Sign in to request a new link</button>
    </div>
  </div>
</div>`;
